import { createApp } from 'vue'
import SvgIcon from '@/icons'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/assets/styles/reset.css'
import '@/assets/styles/border.css'

import zhCn from 'element-plus/es/locale/lang/zh-cn'

// 新增的ECharts相关引入
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { LineChart, PieChart, BarChart } from 'echarts/charts'
import {
  GridComponent,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  DatasetComponent
} from 'echarts/components'
import VChart from 'vue-echarts'

// 注册必须的ECharts组件
use([
  CanvasRenderer,
  LineChart,
  PieChart,
  BarChart,
  GridComponent,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  DatasetComponent
])

// 以下是原有的其他库引入
import 'vxe-table/lib/style.css';
import Vant from 'vant';
import 'vant/lib/index.css';
import VxeUI from 'vxe-pc-ui'
import 'vxe-pc-ui/lib/style.css'
import VxeUITable from 'vxe-table'
import 'vxe-table/lib/style.css'
import ResizeObserver from 'resize-observer-polyfill';
import mitt from 'mitt';

const emitter = mitt();
if (!window.ResizeObserver) {
  window.ResizeObserver = ResizeObserver;
}

const app = createApp(App)


// 全局注册ECharts组件（新增）
app.component('v-chart', VChart)



// 以下是原有注册
SvgIcon(app);
app.use(store)
app.use(router)
app.use(Vant)

// app.use(getIns)
// app.use(getUsbPrinters)
// app.use(selectOnLineUsbPrinter)
// app.use(init)
// app.use(startPrintJobTest)
// app.use(getAllPrinters)
// app.use(getInstance)
// app.use(initSdk)
// app.use(selectPrinter)


app.use(VxeUI)
app.use(VxeUITable)
app.use(ElementPlus, {
  locale: zhCn
})
app.config.globalProperties.$bus = emitter;

app.mount('#app')
